import { useMediaQuery } from '@mui/material'
import { ReactElement } from 'react'
import { FilterResultsMenu } from './FilterResultsMenu'
import { FilterSortDrawer } from './filterSortDrawer/FilterSortDrawer'

interface Props {
  visible: boolean
  setVisible: (v: boolean) => void
}

const Filters = (props: Props): ReactElement => {
  const { visible, setVisible } = props
  const above1460px = useMediaQuery('(min-width:1460px)')

  if (above1460px) {
    return <FilterResultsMenu />
  }

  return (
    <FilterSortDrawer visible={visible} onClose={() => setVisible(false)} />
  )
}

export default Filters
